import { logStartGreyError } from 'owa-analytics-start';
import { SourceIdPartDelimiter } from 'owa-client-types/lib/SourceIdPartDelimiter';

/**
 * Creates a sourceId from the three component parts
 * @param coprincipalSourceIdentifier The identifier for the coprincipal account, or the persistenceId when acctPersistenceIdBasedSourceIds is enabled
 * @returns a string represeting the source
 */
export function buildCoprincipalSourceId(coprincipalSourceIdentifier: string): string {
    if (!coprincipalSourceIdentifier) {
        const errorMessage = 'AcctSourceId-EmptyCoprincipalIdentifier';
        const e = new Error(errorMessage);
        /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param, owa-custom-rules/telemetry-event-name-format -- (https://aka.ms/OWALintWiki)
         * BASELINE: DO NOT COPY/PASTE!
         * undefined
         *	> Argument at index 1 for logStartGreyError must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo
         (https://aka.ms/OWALintWiki)
                 * Baseline. Dev touching this file must update to pass the active MailboxInfo; Docs: https://aka.ms/owa-analytics-mailboxinfo
                 * undefined
                 *	> MailboxInfo must be passed into the function to identify the account.
                 (https://aka.ms/OWALintWiki)
                         * Baseline. DO NOT COPY AND PASTE! Grandfathering existing event names; Devs who touch this file should update Event Names to follow Outlook Telemetry Naming Standards
                         *	> Invalid Outlook telemetry EventName "AcctSourceId-EmptyCoprincipalIdentifier": must contain only letters, numbers, or underscores. */
        logStartGreyError('AcctSourceId-EmptyCoprincipalIdentifier', undefined, e, {
            co: typeof coprincipalSourceIdentifier,
        });
    }

    return coprincipalSourceIdentifier;
}

/**
 * Creates a sourceId from the three component parts
 * @param coprincipalSourceIdentifier The identifier for the coprincipal account, or the persistenceId when acctPersistenceIdBasedSourceIds is enabled
 * @param resourceType The type of resource
 * @param resourceSourceIdentifier The identifier for the resource account
 * @returns a string represeting the resource source
 */
export function buildResourceSourceId(
    coprincipalSourceIdentifier: string,
    resourceType: string,
    resourceSourceIdentifier: string
): string {
    if (!resourceSourceIdentifier) {
        const errorMessage = 'AcctSourceId-EmptyResourceIdentifier';
        const e = new Error(errorMessage);
        /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param, owa-custom-rules/telemetry-event-name-format -- (https://aka.ms/OWALintWiki)
         * BASELINE: DO NOT COPY/PASTE!
         * undefined
         *	> Argument at index 1 for logStartGreyError must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo
         (https://aka.ms/OWALintWiki)
                 * Baseline. Dev touching this file must update to pass the active MailboxInfo; Docs: https://aka.ms/owa-analytics-mailboxinfo
                 * undefined
                 *	> MailboxInfo must be passed into the function to identify the account.
                 (https://aka.ms/OWALintWiki)
                         * Baseline. DO NOT COPY AND PASTE! Grandfathering existing event names; Devs who touch this file should update Event Names to follow Outlook Telemetry Naming Standards
                         *	> Invalid Outlook telemetry EventName "AcctSourceId-EmptyResourceIdentifier": must contain only letters, numbers, or underscores. */
        logStartGreyError('AcctSourceId-EmptyResourceIdentifier', undefined, e, {
            rt: resourceType, // resource type is non PII
            re: typeof resourceSourceIdentifier,
        });
    }

    return [
        buildCoprincipalSourceId(coprincipalSourceIdentifier),
        resourceType,
        resourceSourceIdentifier,
    ].join(SourceIdPartDelimiter);
}
